import SuccessStoriesHead from '../../containers/success-stories/head';

export default SuccessStoriesHead;
